<template>
  <div class="scroll-list-wrapper" :class="darkClass">
    <van-loading v-if="eventLoading" size="20px">加载中...</van-loading>
    <div v-else class="content">
      <!-- 大事提醒模块 -->
      <div v-if="eventList.length" class="card event-box">
        <h3 class="main-title">大事提醒
          <template>
            <span class="main-title-btn" @click="handleMoreClick">更多<van-icon name="arrow" size="12" /></span>
          </template>
        </h3>
        <event-list :eventList="eventList"></event-list>
      </div>
      <!-- 卖空明细 -->
      <div v-if="shortSaleList.length" class="card event-box">
        <h3 class="main-title">卖空明细</h3>
        <div class="profit-content">
          <van-row class="profit-content-title">
            <van-col span="7" class="time">时间</van-col>
            <van-col span="8">卖空成交</van-col>
            <van-col span="9">占比</van-col>
          </van-row>
          <van-row v-for="(item, index) in shortSaleList" :key="index" class="profit-content-content">
            <van-col span="7" class="time">
              <span>{{ item.tradeDate }}</span>
            </van-col>
            <van-col span="8">{{ changeProfitUnits(item.saleCount, 2) }}</van-col>
            <van-col span="9">{{ showPE(item.changePer) }}</van-col>
          </van-row>
        </div>
      </div>
      <!-- 公告列表模块 -->
      <div class="card">
        <h3 class="main-title">公司公告</h3>
        <div class="tabs-wrapper" v-if="classify">
          <div class="tabs-box">
            <div class="tabs-item" :class="afficheFilter.group === item.value ? 'active' : null" v-for="item in tabsList"
              :key="item.value" @click="changeTabs(item.value)">{{ item.label }}</div>
          </div>
        </div>
        <van-loading v-if="afficheLoading" size="20px">加载中...</van-loading>
        <div v-else class="scroll-box" ref="scrollBox">
          <van-empty v-if="!afficheList.length" description="暂无数据" />
          <van-list ref="list" v-show="afficheList.length" v-model="afficheFilter.isFetchingMore"
            :finished="afficheFilter.finished" finished-text="没有更多了" :immediate-check="false"
            :error.sync="afficheFilter.error" error-text="查看更多" @load="onLoad">
            <div class="news">
              <div class="news-list">
                <div class="news-list-item-wrapper" v-for="news in afficheList" :key="news.id + news.ctime">
                  <div class="news-list-item" @click="handleItemClick(news)">
                    <div class="item-info">
                      <h3 class="item-info-title">
                        {{ news.title }}
                      </h3>
                      <div class="item-info-meta">
                        <span class="news-source">{{ formatNewsItemDate(news.ctime) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
      <div class="disclaimer">{{ disclaimer }}</div>
    </div>
  </div>
</template>

<script>
import {
  affiche_list,
  event_list,
  sale_list
} from '@/api/b2b-news';
import { List, Icon, Empty, Toast, Loading, Col, Row } from 'vant';
import dayjs from 'dayjs';
import event from './components/event.vue';
import { isDark } from './utils/oemUtils';
import { disclaimer } from './utils/article';
import { round } from 'lodash-es';

export default {
  name: 'BreakingNews',
  components: {
    [event.name]: event,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
    [List.name]: List,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row,
    [Loading.name]: Loading,
  },
  computed: {
    darkClass() {
      return isDark() ? 'dark' : '';
    },
  },
  data() {
    return {
      eventList: [],
      shortSaleList: [],
      eventLoading: true,
      afficheLoading: true,
      afficheList: [],
      afficheFilter: {
        page: 0,
        pageSize: 20,
        isFetchingMore: false,
        finished: false,
        error: false,
        group: '',
      },
      tabsList: [
        { value: '', label: '全部公告' },
        { value: 'f1001', label: '业绩公告' },
        { value: 'f1002', label: '重大事项' },
        { value: 'f1003,f1004', label: '其他公告' },
      ],
      classify: false,
      disclaimer,
    };
  },
  async mounted() {
    await this.fetchEventsList();
    await this.fetchSaleList();
    await this.initReport();
    this.eventLoading = false;
  },
  methods: {

    // lodash 的round方法注册
    loadshRound(key, precision = 0) {
      return round(key, precision).toFixed(this.$num.num_2);
    },
    showPE(pe) {
      return pe ? `${this.loadshRound(pe, this.$num.num_2)  }%` : '';
    },
    changeProfitUnits(value) {
      const num_10000 = 10000;
      if (value - 1 < 0) {
        return `${this.loadshRound(value * num_10000, this.$num.num_2)  }股`;
      } else if (value - num_10000 > 0) {
        return `${this.loadshRound(value / num_10000, this.$num.num_2)  }亿股`;
      } else {
        return `${this.loadshRound(value, this.$num.num_2)  }万股`;
      }
    },
    changeTabs(value) {
      this.afficheFilter.group = value;
      this.initReport();
    },
    /**
     * @description 大事提醒
     */
    fetchEventsList() {
      const { stock, accessKey } = this.$route.query;
      return event_list({
        accessKey,
        stock,
        cate: 'all',
        page: 0,
        pageSize: 3,
      }).then(res => {
        if (res.code === 0 && res.data && res.data.length) {
          const arr = [];
          res.data.forEach(item => {
            // 屏蔽标题跳转
            item.jumpUrl = '';
            item.showExpand = false;
            arr.push(item);
          });
          this.eventList = arr.slice(0, this.$num.num_3);
        }
        this.eventLoading = false;
      }).catch(() => {
        this.eventLoading = false;
        this.fetchSaleList();
      });
    },
    /**
     * @description 卖空明细
     */
    fetchSaleList() {
      const { stock, market, accessKey } = this.$route.query;
      const marketStock = `${market}_${stock}`;
      return sale_list({
        accessKey,
        stock: marketStock,
        size: 4
      }).then(res => {
        const { code, data } = res;
        if (code === 0 && data && data.length) {
          this.shortSaleList = data.slice(0, this.$num.num_4);
        }
      }).catch(() => {
        this.initReport();
      });
    },
    /**
     * @description 获取数据 通过query和this.afficheFilter获取参数
     */
    fetchNewsList() {
      const { page, pageSize, group } = this.afficheFilter;
      const { stock, market, accessKey } = this.$route.query;
      return affiche_list({
        stock,
        market,
        page,
        pageSize,
        accessKey,
        group
      }).then(res => {
        if (res.code === 0) {
          const resArr = res.data || [];
          if (!this.classify) {
            this.classify = res.classify;
          }
          if (page === 0) {
            this.afficheList = resArr;
          } else {
            this.afficheList = this.afficheList.concat(resArr);
          }

          // 如果数量与pageSize相同则证明还有下一页。
          this.afficheFilter.error = resArr.length === pageSize;
          this.afficheFilter.finished = resArr.length !== pageSize;
        } else {
          this.afficheFilter.error = false;
          this.afficheFilter.finished = true;
        }
      }).catch(() => {
        this.afficheFilter.error = false;
        this.afficheFilter.finished = true;
      });
    },
    /**
     * @description 下滑加载
     */
    onLoad() {
      if (this.afficheFilter.finished) {
        return;
      }
      this.afficheFilter.page += 1;
      this.afficheFilter.isFetchingMore = true;
      this.fetchNewsList().finally(() => {
        this.afficheFilter.isFetchingMore = false;
      }).then(() => {
        // 标记最小高度,防止ios高版本webview监听v-if导致的高度变化导致页面向上移动
        this.$refs.scrollBox.style.minHeight = `${this.$refs.scrollBox.clientHeight}px`;
      });
    },
    /**
     * @description 上拉刷新+初始化
     */
    initReport() {
      this.afficheFilter.page = 0;
      this.afficheFilter.finished = false;
      this.afficheLoading = true;
      this.fetchNewsList().finally(() => {
        this.afficheLoading = false;
      }).then(() => {
        this.$refs.scrollBox.style.minHeight = '';
        // 标记最小高度,防止ios高版本webview监听v-if导致的高度变化导致页面向上移动
        this.$refs.scrollBox.style.minHeight = `${this.$refs.scrollBox.clientHeight}px`;
      });
    },
    /**
     * @description 点击跳转详情页
     */
    handleItemClick(news) {
      const { id } = news;
      const { accessKey } = this.$route.query;
      this.$native.openNewWebview(`/afficheDetail?id=${id}&accessKey=${accessKey}`);
    },
    /**
     * @description 公告时间类型
     */
    formatNewsItemDate(val) {
      return !val ? '' : dayjs(val * this.$num.num_1000).format('YYYY-MM-DD');
    },
    /**
     * @description 点击跳转大事提醒更多页面
     */
    handleMoreClick() {
      const { stock, accessKey } = this.$route.query;
      this.$native.openNewWebview(`/moreAffiche?stock=${stock}&accessKey=${accessKey}`);
    },
  },
};
</script>

<style lang="less" scoped>
.scroll-list-wrapper {
  min-height: 100vh;

  &.dark {
    background: #313131;
  }
}

.jump-affiche-detail {
  display: inline-block;
  margin-left: 6px;
  color: #4e88ff;
}

.card {
  background: #fff;
}

.profit-content {
  font-size: 14px;
  text-align: right;
  padding: 0 10px;

  .time {
    text-align: left;
  }

  .profit-content-title {
    margin-top: 10px;
  }

  .profit-content-content {
    margin-top: 10px;
  }
}

.event-box {
  padding-bottom: 10px;
  margin-bottom: 10px;
}

h3 {
  font-size: 16px;
  font-weight: 400;
}

.content {
  height: 100%;
}

.main-title {
  padding: 14px 15px 0 21px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;

  &::before {
    content: '';
    position: relative;
    top: 1px;
    left: -6px;
    display: inline-block;
    width: 2px;
    height: 12px;
    line-height: 14px;
    // background: #D2A55D;
    background: #e34d59;
  }

  &-btn {
    text-align: right;
    font-weight: 400;
    font-size: 12px;
    float: right;
    color: #a3a3a3;
    line-height: 24px;
  }
}

.tabs-wrapper {
  padding: 20px 15px 6px;
}

.tabs-box {
  display: flex;
  margin: 0 20px;
  border-radius: 8px;
  padding: 2px;
  height: 28px;
  background-color: @color-bg-gray-tab;
  overflow: hidden;
}

.tabs-item {
  flex: 1;
  position: relative;
  line-height: 30px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  font-weight: 500;
  color: @color-text-gray-tab;

  &:nth-last-child(1) {
    margin-right: 0;

    &::after {
      display: none;
    }
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 8px;
    right: -1px;
    width: 1px;
    height: 10px;
    background-color: #dddddd;
  }

  &.active {
    color: #333333;
    background-color: #fefffe;

    &::after {
      content: "";
      display: none;
    }
  }
}

.news-list .news-list-item-wrapper+.news-list-item-wrapper .news-list-item {
  .hairline("top");
}

.news-list-item {
  padding: 12px 0;
  margin: 0 15px;
  display: flex;

  .item-info {
    flex: 1;

    &-title {
      color: #333;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    &-meta {
      font-size: 12px;
      color: #999;
      line-height: 17px;
      margin-top: 15px;

      .news-source {
        margin-right: 10px;
      }
    }
  }

  .item-figure {
    padding-top: 10px;
    width: 90px;
    height: 70px;
    flex-shrink: 0;
    margin-left: 20px;

    .img-wrapper {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.news-list-item--read {
  opacity: 0.5;
}

.van-loading {
  height: 100vh;
  line-height: 100px;
  text-align: center;
}

.disclaimer {
  font-size: 12px;
  color: #a3a3a3;
  text-align: justify;
  line-height: 20px;
  padding: @spacing-medium @spacing-medium @spacing-medium*2;
}

.text-left {
  text-align: left;
}

.dark {
  .content {
    // background-color: @dark-color-bg-page;

    .tabs-box {
      background-color: #252525;

      .tabs-item {
        color: @dark-color-text-gray;

        &::after {
          background-color: #333333;
        }

        &.active {
          color: #d2d2d2;
          background-color: #323232;
        }
      }
    }
  }

  .profit-content {
    color: #d2d2d2;

    .time {

      color: @dark-color-text-gray;
    }
  }

  .news-list .news-list-item-wrapper+.news-list-item-wrapper .news-list-item {
    .hairline("top", #313131);
  }

  .news {
    background-color: @dark-color-bg-page;

    .item-info-title {
      color: @dark-color-text-primary;
    }

    .item-info-meta {
      color: @dark-color-text-gray;
    }
  }

  // 大事提醒
  .main-title {
    color: @dark-color-text-primary;

    &-btn {
      color: @dark-color-text-primary;
    }
  }

  .card {
    background: @dark-color-bg-page;
  }
}
</style>
